module.exports = __webpack_public_path__ + "fonts/mallorymp-bold-webfont.9368ad94db5da7df79891f477464467d.woff";